
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import BlocTextForm from '@/components/forms/MailBlocTextForm.vue'

const mailModule = namespace('mail')

@Component({
  components: {
    BaseCardContainer,
    BlocTextForm
  }
})
export default class BlocTextCreate extends Vue {
  @mailModule.Action('createMailBlocTextAction') createMailBlocText: any
  @mailModule.Action('getMailBlocTextsAction') getMailBlocTexts: any

  mounted() {
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.createMailBlocText(data).then(async (data: any) => {
      this.getMailBlocTexts()
      this.$router.push({name: 'BlocTextList'})
    })
  }

  onCancel() {
    this.$router.replace({name: 'BlocTextList'})
  }
}
